import SelectableTile from '@carvana/ds-selectable-tile';
import { useState } from 'react';
import tileStyles from '@/new-cars/common/SelectableTile.module.css';
import VehicleMakeIcon from '~/components/common/VehicleMakeIcon';
import {
  Content,
  ImageArea,
  ImagePlaceholder,
  OptionName,
  PriceAdd
} from './PackageOptionCard.styles';

type OwnProps = {
  make: string;
};

export default function NoPackageOptionAvailableCard({ make }: OwnProps) {
  const [isImageBroken, setIsImageBroken] = useState(false);

  // The backend does not return an image for the no-options tile, so we
  // reconstruct the RIVAL fallback asset URL from the make.
  const fallbackImageUrl = `https://vexrival.fastly.carvana.io/rival/lip/${make.toLowerCase()}_options_fallback.png`;

  return (
    <SelectableTile
      className={tileStyles.tile}
      selected
      tabIndex={-1}
      data-analytics-id="New Cars"
      data-analytics-attributes={JSON.stringify({
        level: 'Options',
        section: 'Packages',
        text: 'No options or packages',
        tileAction: 'selected'
      })}
      data-testid="package-option-card-no-options"
      value="no-options"
    >
      <ImageArea className="bg-background-weak">
        {isImageBroken ? (
          <ImagePlaceholder>
            <VehicleMakeIcon aria-hidden="true" make={make} size={80} />
          </ImagePlaceholder>
        ) : (
          <img
            alt=""
            className="h-full w-full object-contain"
            onError={() => setIsImageBroken(true)}
            src={fallbackImageUrl}
          />
        )}
      </ImageArea>
      <Content>
        <OptionName>No options or packages</OptionName>
        <PriceAdd>+$0</PriceAdd>
      </Content>
    </SelectableTile>
  );
}
